import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingEmail: false,
  saveLoading: false,
  disciplinaryActionsLength: 0,
  disciplinaryActions: [],
  disciplinaryActionsError: "",
  emailError: "",
  formError: "",
};

export default function DisciplinaryActionsReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_DISCIPLINARY_ACTIONS:
      return { ...state, loading: action.payload };
    case actions.LOADING_EMAIL_SEND:
      return { ...state, loadingEmail: action.payload };
    case actions.SAVE_LOADING_DISCIPLINARY_ACTIONS:
      return { ...state, saveLoading: action.payload };
    case actions.GET_DISCIPLINARY_ACTIONS:
      return {
        ...state,
        disciplinaryActions: action.payload.disciplinaryActions,
        disciplinaryActionsLength: action.payload.disciplinaryActionsLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.DISCIPLINARY_ACTIONS_FAIL:
      return { ...state, disciplinaryActionsError: action.payload };
    case actions.EMAIL_ERROR:
      return { ...state, emailError: action.payload };
    default:
      return state;
  }
}
